// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"05b2d983","302":"dfc1ddf7","445":"7745d3f5","974":"4145092e"}[chunkId] + ".chunk.js";
};